import { DataCardinalityEnum } from '../../../shared/enums/data-cardinality.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { ReportScheduleTypeEnum } from '../enums/report-schedule-type.enum';
import { ReportStatusEnum } from '../enums/report-status.enum';
import { ReportTypeEnum } from '../enums/report-type.enum';

/**
 * Report DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.REPORT)
export class ReportSearchDto extends BaseSearchDto {
	name!: string;
	status!: ReportStatusEnum;
	type!: ReportTypeEnum;
	cardinality!: DataCardinalityEnum;
	description?: string;
	isSystem!: boolean;
	scheduleType!: ReportScheduleTypeEnum;
	scheduleCron?: string;
	files?: FileDto[];
	tags?: TagListDto[];

	displayValue(): string {
		return `${this.name}`;
	}

	shortDisplayValue(): string | null {
		return null;
	}

	periodDisplayValue(): string | null {
		return null;
	}

	extraDisplayValue(): string | null {
		return null;
	}

	pillDisplayValue(): string {
		return this.status;
	}
}
